export const {
  REACT_APP_API_BASE_URL,
  REACT_APP_API_GESINTEL_BASE_URL,
  REACT_APP_DATES_PRODUCTION_STU,
  REACT_APP_ENVIRONMENT,
  REACT_APP_GOOGLE_ANALYTICS_KEY = null,
  REACT_APP_GOOGLE_TASK_MANAGER_ID = null,
  REACT_APP_HOTJAR_ID = null,
  REACT_APP_HOTJAR_SNIPPET_VERSION = null,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_MERCADO_PUBLICO_PROVEEDOR_URL,
  REACT_APP_MERCADO_PUBLICO_LOGIN_PATH,
  REACT_APP_OPTIMIZELY_KEY = null,
  REACT_APP_UNIQUE_PASS_SEED,
  REACT_APP_TAXES_KEY_SEED,
  REACT_APP_API_MOCK_SEND_EMAIL,
  REACT_APP_API_MOCK_CCS,
  REACT_APP_FEATURE_FLAG_FOREIGN_ENROLLMENT,
  REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_ENABLED,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_NATURAL_CHECKS,
  REACT_APP_FEATURE_FLAG_UNIQUE_PASS,
  REACT_APP_HELP_URL,
  REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED,
  REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
export const isLocalEnv = process.env.REACT_APP_ENVIRONMENT === 'local' || process.env.REACT_APP_ENVIRONMENT === 'dev'
